export const WIZARD_QUOTES = [
  'Thy thumbnail is cursed with poor composition. Let me bless it with alignment.',
  'Engagement lies not in pixels, but in prophecy.',
  'ALT text is the sacred incantation of visibility.',
  'Too much text, mortal. The gods of click-through shall not be pleased.',
  'Color must clash, or it must command. Choose wisely.',
  'You uploaded a square. This offends the spirits of aspect ratio.',
  'Let the eyes lead the scroll. Place thy face near the golden point.',
  'One border to rule them all. Preferably neon green.',
  'Beware the sin of centered text. It weakens the spell.',
  'Use contrast like a dagger. Strike swiftly.',
  'If your thumbnail whispers, it shall not be heard by the gods of feed.',
  'The algorithm devours the unbold. Go forth in saturation.',
  'Thumbnails are not for mortals. They are for lords of the scroll.',
  'Clickbait is a dark art. Wield it with irony, or not at all.',
  'Seek not perfection, but intrigue.'
];
